module.exports = __webpack_public_path__ + "img/appstore_page.e374ae7.svg";